import Img from "gatsby-image";
import {Link,graphql} from "gatsby";
import React from "react";
import {Link as ScrollLink} from "react-scroll/modules";
import ShareButtons from 'components/common/share';

import Parser from 'html-react-parser';
import domToReact from 'html-react-parser/lib/dom-to-react';

const styleImage = {
    position:"static"
}

class MainBannerSection extends React.Component {

    constructor(props) {
        super(props);
    }

    transformHtmlFromPrismic(strHtml) {
        let i=0
        return Parser(strHtml, {
            replace: (domNode) => {
                if(i===0 && domNode && domNode.name === 'p') {
                    i++
                    return (
                        <p className="major">{domToReact(domNode.children)}</p>
                    )
                }
            },
        });
    }

    render() {
        const {title,description,bannercta,bannerimage} = this.props.fields
        return (
            <section
                className="banner style1 orient-left content-align-left image-position-right fullscreen onload-image-fade-in onload-content-fade-right">
                <div className="content">
                    <h1>{title.text}</h1>
                    {this.transformHtmlFromPrismic(description.html)}
                    <ul className="actions stacked">
                        {bannercta ? (
                            <li><Link className="button primary fit" to={`/blog/${bannercta.uid}`}>{bannercta.document[0].data.title.text}</Link></li>
                        ) : ''}
                        <li><ScrollLink className="button fit" activeClass="active" to="mapElements" spy={true}
                                        smooth={true} duration={250}>Mappa del viaggio</ScrollLink></li>
                        <li><ScrollLink className="button fit" activeClass="active" to="tagsmapElements" spy={true}
                                        smooth={true} duration={250}>Elenco dei tags</ScrollLink></li>
                        <li><ScrollLink className="button fit" activeClass="active" to="spotlightsElements" spy={true}
                                        smooth={true} duration={250}>Ultimi articoli</ScrollLink></li>
                    </ul>
                    <span>Condividi questo sito con i tuoi amici!</span>
                    <ShareButtons/>
                </div>
                <div className="image">
                    <Img fluid={bannerimage.localFile.childImageSharp.fluid} style={styleImage}/>
                </div>
            </section>
        )
    }
}

export default MainBannerSection

export const pageQuery = graphql`
  fragment MainBannerSection on PrismicHomepage {
    data {
      title {
      	text
    	}
      description {
        html
      }
      bannercta {
          uid
          document {
              data {
                  title {
                      text
                  }
              }
          }
      }
      bannerimage {
        localFile {
          childImageSharp {
              fluid(maxWidth: 1200, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
        }
      }
      ogimage {
        localFile {
            childImageSharp {
                fixed(width: 500, height: 261) {
                    ...GatsbyImageSharpFixed
                }
            }
        }
      }
    }
  }
  `